export default "__VITE_ASSET__BhpIt0Jw__"